import { render, staticRenderFns } from "./discount_list.vue?vue&type=template&id=5da174ca&scoped=true&"
import script from "./discount_list.vue?vue&type=script&lang=js&"
export * from "./discount_list.vue?vue&type=script&lang=js&"
import style0 from "./discount_list.vue?vue&type=style&index=0&id=5da174ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da174ca",
  null
  
)

export default component.exports